module.exports = __webpack_public_path__ + "static/media/ncash.64a77506.svg";